import { Injectable } from '@angular/core'
import { User } from '../types'

@Injectable({
   providedIn: 'root'
})
export class UserService {

   private _user!: User

   get clientKey() {
      return this.user.clientKey
   }
   get userId() {
      return this.user.userId
   }

   get user() {
      return this._user
   }

   get remaining() {
      return this._user.remaining ?? -1
   }

   set remaining(quotum: number) {
      this._user.remaining = quotum
   }

   constructor() {
      // todo set User from API
      this.setUser({ id: 'default', remaining: -1, maxRemaining: -1})
   }

   setUser(user: User) {
      const dummyUser: User = { id: 'session:ui', clientKey: 'exl.PRIMO_RA.PPRD', userId: new Date().getFullYear() + new Date().getDay() + '-uitest', remaining: -1, maxRemaining: -1, type: 'anonymous' }
      this._user = { ...dummyUser, ...user }
      // make sure to set user type
      const u = this._user?.userId?.toLocaleLowerCase()
      if (u?.startsWith('session:')) {
         this._user.type = 'anonymous'
      }
      else if(u?.startsWith('anonymous-')) {
         this._user.type = 'anonymous'
      }
      else {
         this._user.type = 'logged-in'
      }
   }
}
